import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getIncidentComments(companyId, incidentId) {
	return dataTransferWrap(
		ModulesMap.INCIDENT_COMMENTS,dtConfig[ModulesMap.INCIDENT_COMMENTS].getIncidentComments,
		{
			urlParams: {
				companyId,
        incidentId,
			},
		},
	)
}

function createIncidentComment(companyId, incidentId, data) {
	return dataTransferWrap(ModulesMap.INCIDENT_COMMENTS,dtConfig[ModulesMap.INCIDENT_COMMENTS].createIncidentComment, {
		urlParams: {
			companyId,
      incidentId,
		},
		...data,
	})
}

function getIncidentComment(companyId, incidentId, commentId) {
	return dataTransferWrap(ModulesMap.INCIDENT_COMMENTS,dtConfig[ModulesMap.INCIDENT_COMMENTS].getIncidentComment, {
		urlParams: {
			companyId,
      incidentId,
			commentId,
		},
	})
}

function patchIncidentComment(companyId, incidentId, commentId, data) {
	return dataTransferWrap(ModulesMap.INCIDENT_COMMENTS,dtConfig[ModulesMap.INCIDENT_COMMENTS].patchIncidentComment, {
		urlParams: {
			companyId,
      incidentId,
			commentId,
		},
		...data,
	})
}

function putIncidentComment(companyId, incidentId, commentId, data) {
	return dataTransferWrap(ModulesMap.INCIDENT_COMMENTS,dtConfig[ModulesMap.INCIDENT_COMMENTS].putIncidentComment, {
		urlParams: {
			companyId,
      incidentId,
			commentId,
		},
		...data,
	})
}

function deleteIncidentComment(companyId, incidentId, commentId) {
	return dataTransferWrap(ModulesMap.INCIDENT_COMMENTS,dtConfig[ModulesMap.INCIDENT_COMMENTS].deleteIncidentComment, {
		urlParams: {
			companyId,
      incidentId,
			commentId,
		},
	})
}

export default {
	getIncidentComments,
	getIncidentComment,
	patchIncidentComment,
	putIncidentComment,
	createIncidentComment,
	deleteIncidentComment,
}
